import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { KEY_ENTER_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';

/**
 * Enter sends; Shift+Enter inserts a newline (falls through to Lexical's default
 * LineBreakNode handling). Registered at LOW priority so the mention typeahead
 * menu — which registers Enter at a higher priority while open — always wins
 * Enter when a suggestion is highlighted. When the menu is closed, this handler
 * is the one that fires.
 */
export default function EnterSendPlugin({ onSend }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        if (event && event.shiftKey) {
          return false; // let Lexical insert a line break
        }
        if (event) event.preventDefault();
        onSend();
        return true;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, onSend]);

  return null;
}
